import './line.scss';

const Line = () => {
    return (
        <hr className="line"></hr>
    )
}

export default Line